module.exports = __webpack_public_path__ + "static/media/info.a7f5f8d0.svg";